import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function CGV() {
  return (
    <div>
      <div className="bg-[#EFEBE5] px-6 md:px-12 lg:px-24 py-3">
        <div className="max-w-7xl mx-auto flex items-center gap-2 text-sm font-body text-[#6B6B6B]">
          <Link to="/" className="hover:text-[#2D5016]">Accueil</Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-[#2D5016] font-medium">Conditions Generales de Vente</span>
        </div>
      </div>

      <section className="py-16 md:py-24 px-6 md:px-12 lg:px-24" data-testid="cgv-page">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-4xl font-bold text-[#2C2C2C] mb-12">Conditions Generales de Vente</h1>

          <div className="space-y-8 font-body text-[#2C2C2C]/80 leading-relaxed text-sm">
            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Article 1 — Objet</h2>
              <p>Les presentes Conditions Generales de Vente (CGV) regissent les relations contractuelles entre VisitMonde (RCS 811 258 046, IM 078 150006), ci-apres "l'Organisateur", et toute personne physique effectuant une reservation, ci-apres "le Client". Toute reservation implique l'acceptation sans reserve des presentes CGV.</p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Article 2 — Inscription et reservation</h2>
              <p>La reservation devient effective apres signature du contrat de voyage, versement d'un acompte de 30% du prix total et acceptation des presentes CGV. Le solde est exigible 30 jours avant le depart. Pour toute reservation effectuee moins de 30 jours avant le depart, la totalite du prix est due a la reservation.</p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Article 3 — Prix et paiement</h2>
              <p>Les prix sont indiques en euros, par personne, base chambre double. Ils comprennent les prestations indiquees dans la fiche technique de chaque voyage. Les prix peuvent etre revises a la hausse ou a la baisse pour tenir compte des variations du cout des transports (carburant), des taxes et redevances, et des taux de change. Aucune revision ne peut intervenir moins de 20 jours avant le depart.</p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Article 4 — Modification et annulation par le Client</h2>
              <p>Le client peut annuler son voyage a tout moment, sous reserve du paiement de frais d'annulation calcules comme suit :</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Plus de 60 jours avant le depart : 10% du prix total</li>
                <li>De 60 a 31 jours : 25% du prix total</li>
                <li>De 30 a 21 jours : 50% du prix total</li>
                <li>De 20 a 8 jours : 75% du prix total</li>
                <li>Moins de 8 jours ou non-presentation : 100% du prix total</li>
              </ul>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Article 5 — Modification et annulation par l'Organisateur</h2>
              <p>L'Organisateur se reserve le droit de modifier ou d'annuler un voyage si le nombre minimum de participants n'est pas atteint (8 personnes), sous reserve d'en informer le Client au moins 21 jours avant le depart. En cas d'annulation par l'Organisateur, le Client se verra proposer un voyage de substitution ou le remboursement integral des sommes versees.</p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Article 6 — Responsabilite</h2>
              <p>L'Organisateur est responsable de la bonne execution du contrat conformement aux dispositions du Code du Tourisme. Sa responsabilite peut etre engagee sauf preuve d'un cas de force majeure, du fait du Client ou du fait imprevisible d'un tiers etranger a la fourniture des prestations.</p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Article 7 — Assurance</h2>
              <p>L'Organisateur a souscrit une assurance Responsabilite Civile Professionnelle aupres d'Allianz (contrat n 555 04 182). Une assurance assistance-rapatriement est incluse dans le prix du voyage. L'assurance annulation n'est pas incluse ; il est vivement recommande au Client de souscrire une telle assurance.</p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Article 8 — Reclamations</h2>
              <p>Toute reclamation doit etre adressee par lettre recommandee avec accuse de reception a VisitMonde, 6 place de la Fontaine, 78670 Villennes sur Seine, dans un delai de 30 jours suivant la date de retour du voyage.</p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Article 9 — Donnees personnelles</h2>
              <p>Les donnees personnelles collectees sont traitees conformement au RGPD. Consultez notre <Link to="/politique-de-confidentialite" className="text-[#2D5016] underline">politique de confidentialite</Link>.</p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-semibold text-[#2C2C2C] mb-3">Article 10 — Droit applicable et mediation</h2>
              <p>Les presentes CGV sont soumises au droit francais. En cas de litige, le Client peut recourir gratuitement au mediateur du Tourisme et du Voyage : MTV Mediation Tourisme Voyage, BP 80303, 75823 Paris Cedex 17, <a href="https://www.mtv.travel" target="_blank" rel="noopener noreferrer" className="text-[#2D5016] underline">www.mtv.travel</a>.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
